import React from 'react';

import WestlakeLogo from './WestlakeLogo';
import WestlakeRetargetingContainer from './WestlakeRetargetingContainer';

function WestlakeButton({
    personalization,
    listing,
    page,
    user,
    ...rest
}) {
    return (
        <>
            <style>
                {`
                .westlake-prequalification-button button:hover {
                    background-color: #EBEBEB !important;
                }
            `}
            </style>
            <button
                className="btn btn-block text-size-400 display-flex justify-content-center align-items-center"
                style={{
                    backgroundColor: '#fff',
                    height: '48px',
                    border: '2px solid #C7394F',
                    color: '#C7394F',
                    paddingLeft: '5px',
                    paddingRight: '3px',
                }}
                type="button"
                {...rest}
            >
                {personalization && (
                    <WestlakeRetargetingContainer
                        personalization={personalization}
                        listing={listing}
                        page={page}
                        user={user}
                    />
                )}

                Explore Financing
                <WestlakeLogo className="margin-left-3" />
            </button>
        </>
    );
}

export default WestlakeButton;
